import { useState } from 'react';

enum Tabs {
    LAYOUT = 'layout',
    TABLE = 'table'
}

export const useLayout = () => {
    const [activeTab, setActiveTab] = useState<Tabs>(Tabs.LAYOUT);

    const handleTabChange = (value: string) => {
        setActiveTab(value as Tabs);
    };

    return {
        activeTab,
        handleTabChange
    };
};
